var React = require('react');

function RectangleEmpty (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Rectangle_322","data-name":"Rectangle 322","fill":"#fff","stroke":"#b3b3b3","strokeWidth":"1"},[React.createElement("rect",{"width":"32","height":"32","rx":"4","stroke":"none","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"31","height":"31","rx":"3.5","fill":"none","key":1})]));
}

RectangleEmpty.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = RectangleEmpty;

RectangleEmpty.default = RectangleEmpty;
